import * as React from 'react';
import * as main from "../style.module.scss";
export const Item = ({ letter }) => {
  const [selectedItemIndex, setSelectedItemIndex] = React.useState(-1);

  const showTitle = (index)=>{
    setSelectedItemIndex(index);
  }

  const hideTitle =()=>{
    setSelectedItemIndex(-1)
  }

  return (
    <>
      {letter.map((elem, index) => (
        <div
          className={`col-6 col-md-4 col-lg-3 ${main.item}`}
          key={index}
          onMouseEnter={() => showTitle(index)}
          onMouseLeave={() => hideTitle()}
          onKeyUp={() => showTitle(index)}
          onKeyDown={() => hideTitle()}
          role={"presentation"}
        >
          {
            selectedItemIndex === index &&
            <a href={`./${elem.url}`}>
              <h3>
                Сериал <span>{elem.name}</span> cкачать субтитры
              </h3>
            </a>
          }

          <img
            src={`https://fs.advance.ru/landing-pages/inostrannye_yazyki/subtitry_k_serialam_na_angliyskom_yazyke/${elem.url}.jpg`} alt={`Сериал ${elem.url}`}
            style={{
              filter: selectedItemIndex === index ? "grayscale(100%)" : "grayscale(0%)"
            }}
          />
        </div>
      ))}
    </>
  );
};
